"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { Profile } from "@/features/auth/api/types";
type AccountDraft = {
  name?: string;
  residentialAddress?: string;
  marketingConsent?: boolean;
};
export function useAccountDraft(profile) {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [draft, setDraft] = useState(t0);
  const isStreamer = profile.accountType === "STREAMER";
  const name = draft.name ?? profile.name ?? "";
  const residentialAddress = draft.residentialAddress ?? profile.residentialAddress ?? "";
  const marketingConsent = draft.marketingConsent ?? profile.marketingConsent ?? false;
  const isDirty = marketingConsent !== profile.marketingConsent || name !== (profile.name ?? "") || isStreamer && residentialAddress !== (profile.residentialAddress ?? "");
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setDraft({});
    t2 = value => setDraft(current => ({
      ...current,
      marketingConsent: value
    }));
    t3 = value_0 => setDraft(current_0 => ({
      ...current_0,
      name: value_0
    }));
    t4 = value_1 => setDraft(current_1 => ({
      ...current_1,
      residentialAddress: value_1
    }));
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isDirty || $[6] !== marketingConsent || $[7] !== name || $[8] !== residentialAddress) {
    t5 = {
      isDirty,
      marketingConsent,
      name,
      residentialAddress,
      reset: t1,
      setMarketingConsent: t2,
      setName: t3,
      setResidentialAddress: t4
    };
    $[5] = isDirty;
    $[6] = marketingConsent;
    $[7] = name;
    $[8] = residentialAddress;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}